import { PageController } from '@client/components/_core/layout/PageController';
import { NoteEdit } from '@client/components/claims/NoteEdit';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { useCanCreateComplaintNote } from '../../hooks';

import { complaintFormStore } from '../../store';

export const Route = createFileRoute('/console/$orgId/compliance/complaints/details/$id/manage/note/add')({
    staticData: { presentation: 'overlay' },
    component: NoteAdd,
});

function NoteAdd() {
    const { id } = Route.useParams();
    const orgId = useOrgId();
    const canCreate = useCanCreateComplaintNote();
    const navigate = useNavigate();
    const record = complaintFormStore.use.formData({ throwOnUndefined: false });
    const recordLoaded = record?.id === id;

    const [open, setOpen] = useState(true);

    // A pending record is not an access denial.
    useEffect(() => {
        if (recordLoaded && !canCreate) {
            navigate({
                to: '/console/$orgId/compliance/complaints/details/$id/manage',
                params: { orgId, id },
                replace: true,
            });
        }
    }, [recordLoaded, canCreate, orgId, id]);

    return (
        <PageController route={Route}>
            {recordLoaded && canCreate && (
                <NoteEdit
                    entityId={id}
                    entity="complaint"
                    open={open}
                    type="NOTE"
                    title="Add note"
                    onClose={() => {
                        setOpen(false);

                        navigate({
                            to: '/console/$orgId/compliance/complaints/details/$id/manage',
                            params: {
                                orgId,
                                id,
                            },
                            fromComponent: 'drawer',
                        });
                    }}
                />
            )}
        </PageController>
    );
}
